import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "cash-float-close"
};
var _hoisted_2 = {
  class: "dialog-footer"
};
import { ModalStatus } from "@/constants/modal";
import CashFloatModule from "@/store/modules/cash-float";
import ModalModule from "@/store/modules/modal";
import UserModule from "@/store/modules/user";
import { computed, onUnmounted, reactive, ref } from "vue";
import dayjs from "dayjs";
import { printClosingReceipt } from "@/printing/handlers/receipts";
import { Currencies } from "@/constants/currency";
import { getGroupInfo } from "@/utils/vue-helpers/group";
import { useI18n } from "vue-i18n";
import { LogLevel, LogService } from "@/services/logging";
import { closeCashfloat, getCashBookingsAmount } from "@/utils/vue-helpers/cash-float";
import BookingModule from "@/store/modules/booking";
import { clearShallLogout, shallLogout } from "@/utils/vue-helpers/modal";
import { redirectToLoginPage } from "@/utils/helpers/router.helper";
import AuthModule from "@/store/modules/auth";
import { formatDateTime } from "@/utils/helpers/dates";
import POSConfigModule from "@/store/modules/pos-config";
import AppModule from "@/store/modules/app";
import { resetGrowingCollecitonsFromUI, setDBReset } from "@/utils/vue-helpers/db";
var formLabelWidth = "140px";
export default /*#__PURE__*/_defineComponent({
  __name: 'CashFloatClose',
  setup: function setup(__props) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _withAsyncContext2, _withAsyncContext3;

      var __temp, __restore, _useI18n, t, cashFloatAmount, dialogFormVisible, amount, isLoading, form, amountDifference, closeAmountLabel, hideDialog, unsynchedBookings, closeCashFloat, componentPrintClosingReceipt, _componentPrintClosingReceipt;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _componentPrintClosingReceipt = function _componentPrintClosin2() {
                _componentPrintClosingReceipt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  var _CashFloatModule$cash, _CashFloatModule$cash2, _CashFloatModule$cash3, _CashFloatModule$cash4, _CashFloatModule$cash5, _CashFloatModule$cash6, _POSConfigModule$grou, _CashFloatModule$cash7, _receiptInfo$cashDiff, _CashFloatModule$cash8;

                  var groupInfo, d, impressionDate, seller, firstName, lastName, sellerName, createdAt, openingDate, closedAt, closingDate, msg, uid, initialCashFloat, initialCashFloatStr, totalCashFloat, totalCashSales, totalCashSalesStr, finalAmount, finalAmountStr, cashDiff, cashDiffStr, currency, receiptInfo;
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return getGroupInfo();

                        case 2:
                          groupInfo = _context3.sent;
                          d = dayjs(new Date());
                          impressionDate = formatDateTime(d.toString());
                          seller = UserModule.user;
                          firstName = seller.firstName, lastName = seller.lastName;
                          sellerName = "".concat(firstName && firstName[0].toUpperCase() || "", " ").concat(lastName && lastName[0].toUpperCase() || "");
                          createdAt = dayjs((_CashFloatModule$cash = CashFloatModule.cashFloat) === null || _CashFloatModule$cash === void 0 ? void 0 : _CashFloatModule$cash.createdAt);
                          openingDate = formatDateTime(createdAt.toString());
                          closedAt = (_CashFloatModule$cash2 = CashFloatModule.cashFloat) !== null && _CashFloatModule$cash2 !== void 0 && _CashFloatModule$cash2.closeDate ? dayjs((_CashFloatModule$cash3 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash3 === void 0 ? void 0 : _CashFloatModule$cash3.closeDate) : dayjs((_CashFloatModule$cash4 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash4 === void 0 ? void 0 : _CashFloatModule$cash4.updatedAt);
                          closingDate = formatDateTime(closedAt.toString()); // we take the msg in the most recent user switch

                          msg = form.message;
                          uid = (_CashFloatModule$cash5 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash5 === void 0 ? void 0 : _CashFloatModule$cash5.uid;
                          initialCashFloat = CashFloatModule.cashFloat.startAmount / 100 || 0;
                          initialCashFloatStr = initialCashFloat.toFixed(2);
                          _context3.next = 18;
                          return getCashBookingsAmount();

                        case 18:
                          totalCashFloat = _context3.sent;
                          // const totalCashSales =
                          //   (totalCashFloat - (CashFloatModule.cashFloat?.startAmount || 0)) / 100;
                          totalCashSales = Number((_CashFloatModule$cash6 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash6 === void 0 ? void 0 : _CashFloatModule$cash6.totalCashSales) / 100;
                          totalCashSalesStr = totalCashSales.toFixed(2); // we take the validAmount in the most recent user switch

                          finalAmount = form.cashFloatAmount;
                          finalAmountStr = Number(finalAmount).toFixed(2);
                          cashDiff = finalAmount - totalCashFloat / 100;
                          cashDiffStr = cashDiff.toFixed(2); // get the group currency

                          currency = (_POSConfigModule$grou = POSConfigModule.groupInfo) === null || _POSConfigModule$grou === void 0 ? void 0 : _POSConfigModule$grou.currency;
                          receiptInfo = {
                            subTitle: t("receipt.cash-information"),
                            groupInfo: groupInfo,
                            currency: Currencies[currency] || Currencies.CHF,
                            businessIdField: t("field.vat"),
                            impressionDate: {
                              key: t("receipt.impression-date"),
                              value: impressionDate
                            },
                            openingDate: {
                              key: t("receipt.opening-date"),
                              value: openingDate
                            },
                            closingDate: {
                              key: t("receipt.closing-date"),
                              value: closingDate
                            },
                            seller: {
                              key: t("receipt.seller"),
                              value: sellerName
                            },
                            cf: {
                              key: t("receipt.cash-float-id"),
                              value: uid
                            },
                            message: {
                              key: t("receipt.message"),
                              value: msg
                            },
                            initialCashFloat: {
                              key: t("receipt.initial-cash-float"),
                              value: initialCashFloatStr
                            },
                            totalCashSales: {
                              key: t("receipt.total-cash-sales"),
                              value: totalCashSalesStr
                            },
                            finalCashFloat: {
                              key: t("receipt-final-cash-float"),
                              value: finalAmountStr
                            },
                            cashDifference: {
                              key: t("receipt.cash-difference"),
                              value: cashDiffStr
                            }
                          };
                          LogService.info("Cashfloat ".concat((_CashFloatModule$cash7 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash7 === void 0 ? void 0 : _CashFloatModule$cash7.uid, " receipt, cash difference: ").concat((_receiptInfo$cashDiff = receiptInfo.cashDifference) === null || _receiptInfo$cashDiff === void 0 ? void 0 : _receiptInfo$cashDiff.value), {
                            smtzuid: (_CashFloatModule$cash8 = CashFloatModule.cashFloat) === null || _CashFloatModule$cash8 === void 0 ? void 0 : _CashFloatModule$cash8.uid,
                            receiptInfo: receiptInfo
                          });
                          console.log("closingReceiptInfo");
                          console.log(receiptInfo);
                          printClosingReceipt(receiptInfo);

                        case 31:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));
                return _componentPrintClosingReceipt.apply(this, arguments);
              };

              componentPrintClosingReceipt = function _componentPrintClosin() {
                return _componentPrintClosingReceipt.apply(this, arguments);
              };

              _useI18n = useI18n({}), t = _useI18n.t;
              _withAsyncContext2 = _withAsyncContext(function () {
                return getCashBookingsAmount();
              }), _withAsyncContext3 = _slicedToArray(_withAsyncContext2, 2), __temp = _withAsyncContext3[0], __restore = _withAsyncContext3[1], _withAsyncContext2;
              _context4.next = 6;
              return __temp;

            case 6:
              __temp = _context4.sent;

              __restore();

              cashFloatAmount = __temp;
              dialogFormVisible = ref(true);
              amount = ref(cashFloatAmount);
              isLoading = ref(false);
              form = reactive({
                cashFloatAmount: cashFloatAmount / 100,
                message: ""
              });
              amountDifference = computed(function () {
                return cashFloatAmount / 100 - form.cashFloatAmount !== 0;
              });
              closeAmountLabel = computed(function () {
                var label = t("cashfloat.closing-amount");

                if (!amountDifference.value) {
                  return label;
                }

                return "".concat(label, " - ").concat(t("cashfloat.system-amount"), " ").concat(amount.value / 100);
              });

              hideDialog = function hideDialog() {
                ModalModule.setStatus(ModalStatus.Hidden);
              };

              onUnmounted(function () {
                clearShallLogout();
              });
              unsynchedBookings = computed(function () {
                return Object.keys(BookingModule.bookingsPendingSynchronization).length;
              });

              closeCashFloat = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var cashFloat, unsynchedBookingsUuid, memory, mem;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          // Loading
                          isLoading.value = true;
                          cashFloat = CashFloatModule.cashFloat;

                          if (cashFloat) {
                            _context2.next = 5;
                            break;
                          }

                          LogService.info("No cashfloat found while closing sales", undefined, LogLevel.Error);
                          return _context2.abrupt("return");

                        case 5:
                          _context2.prev = 5;

                          if (unsynchedBookings.value) {
                            unsynchedBookingsUuid = Object.keys(BookingModule.bookingsPendingSynchronization).map(function (it) {
                              return it;
                            });
                            LogService.info("The following bookings were not synched to backend: ".concat(unsynchedBookingsUuid, " while closing the cashfloat with uuid ").concat(cashFloat.uid), {
                              params: {
                                bookingUuids: unsynchedBookingsUuid
                              }
                            });
                          }

                          _context2.next = 9;
                          return closeCashfloat(form.message, cashFloatAmount, {}, form.cashFloatAmount * 100, cashFloat.uid);

                        case 9:
                          _context2.next = 11;
                          return componentPrintClosingReceipt();

                        case 11:
                          // Clear cash float
                          setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    CashFloatModule.setCashFloat(null); // At this point, it's safe for us to reset the db if all data was saved;

                                    _context.next = 3;
                                    return resetGrowingCollecitonsFromUI();

                                  case 3:
                                    setDBReset(true);
                                    isLoading.value = false; // take the user to the logout screen if he shall logout

                                    if (shallLogout.value) {
                                      AuthModule.UserLogOut(); // remove gId parameter if it is set

                                      if (AppModule.gid) {
                                        AppModule.removeGID();
                                      }

                                      redirectToLoginPage();
                                    }

                                    hideDialog();

                                  case 7:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          })), 5000); // Ensure that no booking is remaining when sales are closed

                          BookingModule.clearAllBookings(); // Now lets log current memory consumption

                          try {
                            if (window.performance && window.performance.memory) {
                              memory = window.performance.memory;
                              mem = {
                                date: dayjs().utc().toISOString(),
                                totalJSHeapSize: memory.totalJSHeapSize / (1024 * 1024),
                                usedJSHeapSize: memory.usedJSHeapSize / (1024 * 1024),
                                jsHeapSizeLimit: memory.jsHeapSizeLimit / (1024 * 1024),
                                domMemory: (memory.totalJSHeapSize - memory.usedJSHeapSize) / (1024 * 1024)
                              };
                              LogService.info("Memory consumption after closing sales", {
                                params: {
                                  memoryConsumption: mem
                                }
                              });
                            }
                          } catch (err) {
                            // Couldn't log memory consumption
                            LogService.info("Error when trying to log memory consumption", {
                              params: {
                                error: err
                              }
                            }, LogLevel.Error);
                          }

                          _context2.next = 20;
                          break;

                        case 16:
                          _context2.prev = 16;
                          _context2.t0 = _context2["catch"](5);
                          // console.error(error);
                          // if (cashFloat) {
                          LogService.info("Error while closing cashfloat ".concat(cashFloat.uid), {
                            params: {
                              cashFloat: cashFloat,
                              error: _context2.t0
                            }
                          }, LogLevel.Error); // }

                          throw _context2.t0;

                        case 20:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[5, 16]]);
                }));

                return function closeCashFloat() {
                  return _ref.apply(this, arguments);
                };
              }();
              /**
               * Collects data for closing receipt and print it
               * Triggered when user logs out
               */


              return _context4.abrupt("return", function (_ctx, _cache) {
                var _component_el_input = _resolveComponent("el-input");

                var _component_el_form_item = _resolveComponent("el-form-item");

                var _component_el_form = _resolveComponent("el-form");

                var _component_el_button = _resolveComponent("el-button");

                var _component_el_dialog = _resolveComponent("el-dialog");

                return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
                  modelValue: dialogFormVisible.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                    return dialogFormVisible.value = $event;
                  }),
                  title: _ctx.$t('cashfloat.close'),
                  "show-close": false
                }, {
                  footer: _withCtx(function () {
                    return [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
                      onClick: hideDialog,
                      class: "booking-button"
                    }, {
                      default: _withCtx(function () {
                        return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
                      }),
                      _: 1
                    }), _createVNode(_component_el_button, {
                      type: "primary",
                      loading: isLoading.value,
                      onClick: _cache[2] || (_cache[2] = function ($event) {
                        return closeCashFloat();
                      }),
                      class: "booking-button"
                    }, {
                      default: _withCtx(function () {
                        return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
                      }),
                      _: 1
                    }, 8, ["loading"])])];
                  }),
                  default: _withCtx(function () {
                    return [_createVNode(_component_el_form, {
                      model: form,
                      "label-position": "top"
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_el_form_item, {
                          label: closeAmountLabel.value,
                          "label-width": formLabelWidth
                        }, {
                          default: _withCtx(function () {
                            return [_createVNode(_component_el_input, {
                              type: "number",
                              modelValue: form.cashFloatAmount,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                                return form.cashFloatAmount = $event;
                              }),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])];
                          }),
                          _: 1
                        }, 8, ["label"]), _createVNode(_component_el_form_item, {
                          label: _ctx.$t('receipt.message'),
                          "label-width": formLabelWidth
                        }, {
                          default: _withCtx(function () {
                            return [_createVNode(_component_el_input, {
                              type: "textarea",
                              modelValue: form.message,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                                return form.message = $event;
                              }),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])];
                          }),
                          _: 1
                        }, 8, ["label"]), unsynchedBookings.value ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          class: "warning-message"
                        }, {
                          default: _withCtx(function () {
                            return [_createTextVNode(_toDisplayString(_ctx.$t("booking.not-synced")), 1)];
                          }),
                          _: 1
                        })) : _createCommentVNode("", true)];
                      }),
                      _: 1
                    }, 8, ["model"])];
                  }),
                  _: 1
                }, 8, ["modelValue", "title"])]);
              });

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
});